import produce from 'immer';

import {
  SET_CONNECTED_WALLET,
  SET_PROFILE,
} from './constants';

export const initialState = {
  profile: {},
  wallet: null,
};

// * state key that will stored to localStorage
export const storedKey = [
  'profile',
  'wallet'
];

/* eslint-disable default-case, no-param-reassign */
const clientReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    switch (action.type) {
      case SET_PROFILE:
        draft.profile = action.profile;
        break;
      case SET_CONNECTED_WALLET:
        draft.wallet = action.wallet;
        break;
    }
  });

export default clientReducer;
